import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { LEGACY_IMAGE, STATS, CONTACT } from "../../data";

const Counter = ({ value, label, delay }) => (
  <Reveal delay={delay}>
    <div className="border-l border-white/15 pl-5 py-2">
      <div className="font-head font-black text-5xl md:text-6xl leading-none text-forge">{value}</div>
      <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-plasma/60 mt-3">{label}</div>
    </div>
  </Reveal>
);

export const Legacy = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="legacy" ref={ref} className="relative py-24 md:py-40" data-testid="legacy-section">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 relative">
          <div className="relative overflow-hidden chamfer-tl border border-white/10 aspect-[4/5]">
            <motion.img
              style={{ y }}
              src={LEGACY_IMAGE}
              alt="Engineer at work"
              className="w-full h-[120%] object-cover grayscale-[0.4]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-void/70 to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-2 md:right-6 bg-forge text-void px-6 py-5">
            <div className="font-head font-black text-4xl md:text-5xl leading-none">{CONTACT.since}</div>
            <div className="font-mono text-[10px] uppercase tracking-[0.2em] mt-1">Year one</div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <Reveal>
            <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.25em] text-forge mb-8">
              <span className="w-10 h-px bg-forge" />
              The Legacy
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-head font-bold uppercase tracking-tight text-4xl md:text-6xl leading-[0.92] mb-8">
              A trusted name in power since day one.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-plasma/65 leading-relaxed max-w-xl mb-12">
              Scientific Industries has spent nearly four decades solving the messy reality of
              unstable grids and rising energy costs. Our commitment to quality, reliable
              performance and honest service has built relationships that outlast the equipment itself.
            </p>
          </Reveal>

          <div className="grid grid-cols-2 gap-x-6 gap-y-10">
            {STATS.map((s, i) => (
              <Counter key={s.label} {...s} delay={i * 0.08} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
